module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/efd36fc8af90b031c417299418dda296.svg";